import { useEffect, useState } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

// mui
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Alert, Stack } from '@mui/material';
// components
import AuthPageBanner from '@/component/common/auth-page-banner';
import LoginOtherDrawer from '@/component/auth/login-other-drawer';
import SendMobileDrawer from '@/component/auth/send-mobile.drawer';
// hook
// lib & etc
import { fontWeight } from '@/theme';
import { localGetStorage, localSetStorage } from '@/lib/storage';
import { SFPalette } from '@/lib/color';
import { LOCAL_SESSION, LOCAL_SESSION_TIME } from '@/lib/common/name-space';
import packageJson from '../../../package.json';
import Loading from '@/component/mui/Backdrop';

import { useWeb3AuthConnect, useWeb3AuthUser } from '@web3auth/modal/react';
import { useWeb3 } from '@/contexts/web3Provider';
export default function SignInSns() {
  const version = packageJson.version;
  const appVersion = localStorage.getItem('app_version') || undefined;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [openDrawer, setOpenDrawer] = useState(false);

  const [openSendMobileDrawer, setOpenSendMobileDrawer] = useState(false);
  const [typeLogin, setTypeLogin] = useState();
  // const { web3authCall } = useWeb3();
  const [isLogin, setIsLogin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { connect, loading, isConnected, error } = useWeb3AuthConnect();
  const { getUserInfo } = useWeb3AuthUser();
  const { initializeWeb3Auth, isInitialized, address, clearWeb3Auth } = useWeb3();

  useEffect(() => {
    const re = localGetStorage('snsAddress') || false;
    setTypeLogin(re.typeOfLogin);
    return () => {};
  }, []);

  useEffect(() => {
    if (isLogin) {
      (async () => {
        await setLogin();
      })();
    }

    return () => {};
  }, [isLogin]);

  useEffect(() => {
    (async () => {
      // web3연결되어 있는지 체크
      if (isConnected) {
        await setLogin();
      }
    })();
    return () => {};
  }, [isConnected]);

  const handleSubmit = async () => {
    clearWeb3Auth();
    const re = await connect();
    if (re) {
      setIsLoading(true);
    }
  };

  const setLogin = async () => {
    try {
      if (isConnected) {
        // userInfo가 로드될 때까지 기다리기
        if (!isInitialized) {
          await initializeWeb3Auth();
        }

        const re = localGetStorage(LOCAL_SESSION);
        if (!re) {
          setSession();
        }
        changeLoginType();
        setIsLogin(true);
        navigate('/wallet');
      } else {
        navigate('/signInSns');
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  const setSession = () => {
    const now = new Date();
    const payload = {
      key: LOCAL_SESSION,
      value: {
        sessionTime: now.getTime() + LOCAL_SESSION_TIME,
      },
    };
    localSetStorage(payload);
  };
  const changeLoginType = async () => {
    const res = localGetStorage('snsAddress');
    if (!res) {
      return;
    }
    const userInfo = await getUserInfo();
    const loginType = userInfo?.authConnection ?? 'external';
    const payload = {
      key: 'snsAddress',
      value: {
        ...res,
        typeOfLogin: loginType,
      },
    };
    localSetStorage(payload);
  };

  return (
    <>
      <Container maxWidth="sm">
        <Box pt={4}>
          <AuthPageBanner />
          <Box mb={2.5}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              size="large"
              sx={{
                borderRadius: '100px !important',
              }}
              fullWidth
              onClick={handleSubmit}
            >
              <Typography variant="h6" fontWeight={fontWeight.Bold}>
                SNS {t('button.login')}
              </Typography>
            </Button>
          </Box>
          {/* <NavLink
            to="/signIn"
            style={{
              textDecoration: 'none',
            }}
          >
            <Typography variant="body2" color={SFPalette.grey4}>
              {t('button.backwards')}
            </Typography>
          </NavLink> */}
        </Box>
        <Box pt={4}>
          {typeLogin ? (
            <Stack sx={{ width: '100%' }} spacing={2}>
              <div style={{ textAlign: 'center' }}>{t('message.recentlySns', { typeLogin })}</div>
              {/* <Alert variant="outlined" severity="error">
                최근 사용하신 소셜 로그인 계정은 ‘{typeLogin}’ 입니다.
              </Alert> */}
            </Stack>
          ) : (
            ''
          )}
        </Box>

        <LoginOtherDrawer
          open={openDrawer}
          onClose={() => {
            setOpenDrawer(false);
          }}
        />
        <SendMobileDrawer open={openSendMobileDrawer} onClose={() => setOpenSendMobileDrawer(false)} />
        <Box textAlign="right" mt={5}>
          {process.env.NODE_ENV !== 'production' ? 'Dev' : ''} {version}
          <br />
          {process.env.NODE_ENV !== 'production' ? `${process.env.NODE_ENV}, appV: ${appVersion} ` : ''}
        </Box>
        {/* <Button
          onClick={() => {
            const dappUrl = 'shuffledev1116.hupayx.io';
            const metaMaskDeepLink = `https://metamask.app.link/dapp/${encodeURIComponent(dappUrl)}`;

            // `metamask://dapp?url=${encodeURIComponent(dappUrl)}`;
            window.location.href = metaMaskDeepLink;
          }}
        >
          metamask
        </Button> */}
      </Container>

      <Loading isLoading={isLoading} />
    </>
  );
}
